export default function (context) {
  return {
    key: 'project_data_validation',
    resource: {
      endpoint: 'residential_status',
      filter: {
        'filter.saleType': 'sale',
      },
    },
    type: 'Disclaimer',
    wrapper: false,
    title: {
      id: 'project_data_validation',
      label: context.$t('projectStatisticsStatus'),
    },
    description: context.$t('projectStatisticsDisclaimer'),
    data: ({ data }) => {
      if (!data.data || data.data.length === 0) return
      return data.data.map(item => {
        const label = `${context.$tc('unit', item.count || 2).toLowerCase()} ${
          context.$t('priceMissingArea').split(' ')[1]
        } ${item.missingConditions
          .map(con => context.getTranslation(con))
          .join(', ')
          .toLowerCase()}`

        return { label, count: item.count, items: item.items }
      })
    },
  }
}
